// export const apiUrl = "https://public-api-en.almayadeen.net";
export const apiUrl = "https://beta-en-api.almayadeen.net";
export const mediaUrl = "https://media-en.mangopulse.net";
export const apiKey = "cf681607a7c35bd1bac01b122bf3308c";
export const assetsMenu = `${apiUrl}/assets?platform=headless`;
export const cropRatios: { [key: string]: number } = {
  "1": 1.7,
  "2": 1.2,
  "3": 1,
};

export const QUERY_KEYS = {
  GET_PAGE: "GET_PAGE",
  GET_ASSETS: "GET_ASSETS",
};


export const MENU_KEYS = {
  MAIN: 'h-main',
  REGIONS: 'h-regions',
  FOOTER: 'h-footer'
}

export const ENGLISH_GOOGLE_ANALYTICS_ID = "G-HY42TXC6M8"